<template>
  <div>
    <Row>
      <Form ref="queryAttendanceRecordsForm" :model="query" :label-width="70" label-position="right" inline
            class="index-query-form">
        <Form-item :label="this.$t('ipms.attendance-user.userName.label')" prop="userName">
          <Input v-model="query.userName" :placeholder="$t('ipms.attendance-user.userName.holder')"
                 style="width: 120px"/>
        </Form-item>
        <Form-item :label="this.$t('ipms.attendance-records.attendanceDate.label')" prop="attendanceDate">
          <Date-picker :value="query.attendanceDateBetween" format="yyyy-MM-dd" @on-change="changeDate" type="daterange"
                       :placeholder="this.$t('ipms.attendance-records.attendanceDate.holder')"
                       style="width: 150px"></Date-picker>
        </Form-item>
        <Form-item :label="this.$t('ipms.attendance-user.attendanceGroup.label')" prop="attendanceType">
          <Select v-model="query.attendanceGroup" clearable filterable
                  :placeholder="$t('ipms.attendance-records.attendanceType.holder')" style="width: 120px">
            <Option v-for="item in group" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="this.$t('ipms.attendance-user.userCategory.label')" prop="userCategory">
          <Select v-model="query.userCategory" clearable filterable
                  :placeholder="$t('ipms.attendance-user.userCategory.holder')" style="width: 135px">
            <Option v-for="item in dict.userCategory" :value="item.dictKey"
                    :key="item.dictValue">{{item.dictValue}}
            </Option>
          </Select>
        </Form-item>
        <Form-item :label="this.$t('ipms.attendance-user.userPost.label')" prop="userPost">
          <Select v-model="query.userPost" clearable filterable
                  :placeholder="$t('ipms.attendance-user.userPost.holder')" style="width: 135px">
            <Option v-for="item in dict.userPost" :value="item.dictKey"
                    :key="item.dictValue">{{item.dictValue }}
            </Option>
          </Select>
        </Form-item>
        <!-- <Form-item :label="this.$t('ipms.attendance-user.remark.label')" prop="remark">
          <Input v-model="query.remark" :placeholder="$t('ipms.attendance-user.remark.holder')" style="width: 100px"/>
        </Form-item> -->
        <Form-item :label-width="0">
          <span @click="handleSearch" style="margin: 0 10px;"><Button
            type="primary">{{$t('searchText')}}</Button></span>
          <Button @click="resetSearchForm" type="default">{{$t('resetText')}}</Button>
        </Form-item>
          <Button @click="exportExcel" type="primary" style="margin-right: 10px;float:left">
          {{$t('exportExcel')}}
        </Button>
        <Button @click="openAttendanceRecordsDrawerTable()" type="primary" style="margin-right: 10px;float:right">
          {{$t('newText')}}
        </Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1" style="width:100%;">
      <Table ref="attendanceRecordsTable" :columns="columns" stripe border :data="page.data"
             @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle">
        <!--div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label"
                    :value="item.value"></Option>
          </Select>
          <Button type="primary"
                  :disabled="this.batchOperate.action=='' || $refs.attendanceRecordsTable.getSelection().length == 0"
                  :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' :
            '确 定' }}
          </Button>
        </div>-->
        <Page :current="page.current" :total="page.total" :page-size="page.size" @on-change="handlePageChange"
              show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>

    <el-drawer ref="attendanceRecordsDrawer" :title="this.$t('drawer.title')[attendanceRecordsDrawer.type]"
               :visible.sync="attendanceRecordsDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <attendanceRecords-form ref="attendanceRecordsForm"/>
        <div class="right-drawer__footer" v-if="attendanceRecordsDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="attendanceRecordsDrawer.submiting">{{
            attendanceRecordsDrawer.submiting ? '提交中 ...' : '保 存' }}
          </Button>
          <Button @click="attendanceRecordsDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>

    <el-drawer ref="attendanceRecordsDrawerTable" :title="this.$t('drawer.title')[attendanceRecordsDrawerTable.type]"
               :visible.sync="attendanceRecordsDrawerTable.visible" direction="rtl" size="50%"
               custom-class="right-drawer">
      <div class="right-drawer__content">
        <attendanceRecords-table ref="attendanceRecordsDrawerTable"/>
        <div class="right-drawer__footer" v-if="attendanceRecordsDrawerTable.type!='detail'">
          <Button type="primary" @click="handleTableSubmit()" :loading="attendanceRecordsDrawerTable.submiting">{{
            attendanceRecordsDrawerTable.submiting ? '提交中 ...' : '保 存' }}
          </Button>
          <Button @click="attendanceRecordsDrawerTable.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
  import dict from '@/components/dict'
  import Vue from 'vue';
  import api from '@/api'
  import mixin from '@/libs/mixins/Index'

  import AttendanceRecordsForm from '@/views/ipms/attendance-records/components/Form.vue';
  import AttendanceRecordsTable from '@/views/ipms/attendance-records/components/Table.vue';
  Vue.component('attendanceRecords-form', AttendanceRecordsForm);
  Vue.component('attendanceRecords-table', AttendanceRecordsTable);

  export default {
    name: 'aip-ipms-attendanceRecords-index',
    mixins: [mixin],
    dictParams: ['attendanceGroup','attendanceType','userPost','userCategory'],
    components: {
      'dict-tag': dict
    },
    data() {
      return {
        group: [],
        query: {
          userName: '',
          attendanceType: '',
          userPost: '',
          // remark: '',
          userCategory: '',
          attendanceDateBetween: '',
          attendanceDate:'',
          attendanceDateEnd:''
        },
        page: {
          size: 10,
          current: 1,
          total: 0,
          sort: "id_desc",
          loading: false,
          data: []
        },
        attendanceRecordsDrawer: {
          action: 'add',
          visible: false,
          submiting: false
        },
        attendanceRecordsDrawerTable: {
          action: '',
          visible: false,
          submiting: false
        }/*,
        batchOperate: {
          action: '',
          submiting: false,
          options: [
            {value: 'handleBatchRemove', label: '批量删除'}
          ]
        }*/
      }
    },
    created() {
      api.ipms.AttendanceRecords.getGRoup()
        .then(data => {
          this.group = data
          console.log(this.group, "分组数据")
        }).catch(error => this.page.loading = false)
    },
    methods: {
      changeDate(format_value,date_time){
        console.log(this.query.attendanceDateBetween,"这是时间段")
        console.log(format_value[0],"这是格式化")
        this.query.attendanceDate=format_value[0]
        this.query.attendanceDateEnd=format_value[1]

      },

      handleSearch() {

        this.page.loading = true;
        api.ipms.AttendanceRecords.query(this.query, this.page)
          .then(data => {
            this.page = Object.assign(this.page, data);
            this.page.loading = false;
          }).catch(error => this.page.loading = false)
      },
      openAttendanceRecordsDrawer(attendanceRecords) {
        this.attendanceRecordsDrawer.visible = true
        this.attendanceRecordsDrawer.type = attendanceRecords ? attendanceRecords.type : 'add'
        this.$nextTick(() => {
          if (attendanceRecords) {
            this.$refs['attendanceRecordsForm'].getAttendanceRecords(attendanceRecords.id, attendanceRecords.type)
          } else {
            this.$refs['attendanceRecordsForm'].handleReset()
          }
        })
      },
      openAttendanceRecordsDrawerTable() {
        this.attendanceRecordsDrawerTable.visible = true
        this.attendanceRecordsDrawer.type = 'add';
        this.$nextTick(() => {
          //请求接口  分组 时间
          const query = {
            "attendanceGroup": null,
            "attendanceDate": this.$moment().format("YYYY-MM-DD")
          }
          this.$refs['attendanceRecordsDrawerTable'].initAttendanceRecordsTable(query)
        })
      },
      exportExcel(){
        this.page.loading = true;
        api.ipms.AttendanceRecords.exportExcel(this.query, this.page)
          .then(data => {
            this.page.loading = false;

            if(data.type=='application/json'){
              const reader = new FileReader()
              let that = this;
              reader.onload = function () {
                var res = JSON.parse(reader.result)//此处的msg就是后端返回的msg内容
                that.$Message.error(res.message)
              }
              reader.readAsText(data)
              return;
            }

            const blob = new Blob([data])
            const url = window.URL.createObjectURL(blob)
            const aLink = document.createElement('a')
            aLink.style.display = 'none'
            aLink.href = url
            // let fileName = decodeURIComponent(res.headers['content-disposition'].split('filename=')[1])
            aLink.setAttribute('download', '考勤表.xlsx')
            document.body.appendChild(aLink)
            aLink.click()
            document.body.removeChild(aLink) // 下载完成移除元素
            window.URL.revokeObjectURL(url) // 释放掉blob对象
          }).catch(error => {
              this.page.loading = false
              console.log(error)
          })
      },
      handleSubmit() {
        this.attendanceRecordsDrawer.submiting = true;
        this.$refs.attendanceRecordsForm.handleSubmit(
          data => {
            this.attendanceRecordsDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.attendanceRecordsDrawer.visible = false, 1000);
          },
          () => {
            this.attendanceRecordsDrawer.submiting = false;
          }
        )
      },
      handleTableSubmit() {
        this.attendanceRecordsDrawerTable.submiting = true;
        this.$refs.attendanceRecordsDrawerTable.handleSubmit(
          data => {
            this.attendanceRecordsDrawerTable.submiting = false;
            this.handleSearch();
            setTimeout(() => this.attendanceRecordsDrawerTable.visible = false, 1000);
          },
          () => {
            this.attendanceRecordsDrawerTable.submiting = false;
          }
        )
      },
      deleteAttendanceRecords(id) {
        api.ipms.AttendanceRecords.remove(id)
          .then(response => {
            this.$Message.success(this.$t('successText'))
            this.handleSearch()
          }).catch(error => console.log(error))
      },
      handleBatchRemove(rows) {
        this.batchOperate.submiting = true
        Promise.all(rows.map(item => api.ipms.AttendanceRecords.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e => {
          this.batchOperate.submiting = false
          this.handleSearch()
        })
      }
    },
    computed: {
      columns() {
        return [
          /*{
            type: 'index',
            width: 60,
            align: 'center'
          },*/
          // {key: 'id', width: 100,  fixed:'left',align:'center',type:'selection'},
          {
            key: 'attendanceDate',
            align: 'center',
            width: 230,
            title: this.$t('ipms.attendance-records.attendanceDate.label')
          },
          {key: 'userName', align: 'center', width: 220, title: this.$t('ipms.attendance-user.userName.label')},
          {
            key: 'attendanceGroup',
            align: 'center',

            column:'attendanceGroup',
            filters: this.$t('ipms.attendance-user.attendanceGroup.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.attendanceGroup = value
              this.handleSearch();
            },
            title: this.$t('ipms.attendance-user.attendanceGroup.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.attendanceGroup==t.value).label}</div>
            }
          },
          {
            key: 'userPost', filters: this.$t('ipms.attendance-user.userPost.dictionary'),
            filterMultiple: false, align: 'center', width: 220, title: this.$t('ipms.attendance-user.userPost.label'),
            filterRemote:(value,row)=>{
              this.query.userPost = value
              this.handleSearch();
            },
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.userPost==t.value).label}</div>
            }
          },
          {
            key: 'userCategory',
            filters: this.$t('ipms.attendance-user.userCategory.dictionary'),
            filterMultiple: false,
            align: 'center',
            width: 220,
            filterRemote:(value,row)=>{
              this.query.userCategory = value
              this.handleSearch();
            },
            title: this.$t('ipms.attendance-user.userCategory.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.userCategory==t.value).label}</div>
            }
          },
          {
            key: 'attendanceType',
            filters: this.$t('ipms.attendance-records.attendanceType.dictionary'),
            filterMultiple: false,
            align: 'center',
            width: 230,
            filterRemote:(value,row)=>{
              this.query.attendanceType = value
              this.handleSearch();
            },
            title: this.$t('ipms.attendance-records.attendanceType.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.attendanceType == t.value).label}</div>
            }
          },
          // {key: 'remark', align: 'center', title: this.$t('ipms.attendance-user.remark.label'),},
          {
            title: this.$t('operateText'),
            align: 'center',
            fixed: "right",
            width:160,
            key: 'handle',
            render: (h, params) => {
              return <div style="display: flex;justify-content: space-around;">
                <a href="javascript:void(0);" onClick={() => this.openAttendanceRecordsDrawer({
                  id: params.row.id,
                  type: 'edit'
                })}>{this.$t('editText')}</a>
                <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true}
                        onOn-ok={() => this.deleteAttendanceRecords(params.row.id)}>
                  <a href="javascript:void(0);">{this.$t('deleteText')}</a>
                </Poptip>
              </div>
            }
          }
        ]
      }
    }
  }
</script>
